var v = Object.defineProperty, F = Object.defineProperties;
var K = Object.getOwnPropertyDescriptors;
var y = Object.getOwnPropertySymbols;
var Q = Object.prototype.hasOwnProperty, w = Object.prototype.propertyIsEnumerable;
var b = (t, r, u) => r in t ? v(t, r, { enumerable: !0, configurable: !0, writable: !0, value: u }) : t[r] = u, i = (t, r) => {
  for (var u in r || (r = {}))
    Q.call(r, u) && b(t, u, r[u]);
  if (y)
    for (var u of y(r))
      w.call(r, u) && b(t, u, r[u]);
  return t;
}, l = (t, r) => F(t, K(r));
var n = (t, r, u) => new Promise((s, a) => {
  var q = (e) => {
    try {
      o(u.next(e));
    } catch (c) {
      a(c);
    }
  }, d = (e) => {
    try {
      o(u.throw(e));
    } catch (c) {
      a(c);
    }
  }, o = (e) => e.done ? s(e.value) : Promise.resolve(e.value).then(q, d);
  o((u = u.apply(t, r)).next());
});
import { u as m, a as f } from "./query-client-DZ5Df1It.js";
import { u as C } from "./useMutation-DFzOBEuf.js";
import { m as M, r as p } from "./define-element-XpjsV6s1.js";
function x() {
  m();
  const t = f({
    queryKey: ["clubs"],
    queryFn: () => n(null, null, function* () {
      return yield p("clubs");
    })
  }), r = M(() => {
    const u = t.data.value;
    return !u || u.error ? [] : Object.values(u).sort((s, a) => Number(s.sort) - Number(a.sort));
  });
  return l(i({}, t), {
    clubs: r
  });
}
function O(t) {
  const r = m(), u = f({
    queryKey: ["club", t],
    queryFn: () => n(null, null, function* () {
      return yield p("club");
    })
  }), s = C({
    mutationFn: (a) => n(null, null, function* () {
    }),
    onSuccess: () => {
      r == null || r.invalidateQueries({ queryKey: ["club", t] });
    }
  });
  return l(i({}, u), {
    clubMutation: s
  });
}
export {
  x as a,
  O as u
};
